// eslint-disable-next-line no-shadow
export enum UserTypeEnum {
  PATIENT = 'patient',
  PROFESSIONAL = 'professional',
  SUPERVISOR = 'supervisor',
}
